'use client';

import { useEffect } from 'react';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import LoginForm from './components/LoginForm';
import { analytics } from '@/lib/analytics';

export default function LoginPage() {
  useEffect(() => {
    analytics?.trackPageView('/login');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header with Shipping Equipment Background */}
        <div className="relative bg-gradient-to-br from-slate-800 via-slate-700 to-slate-900 py-16 border-b border-border overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] bg-repeat"></div>
          </div>
          
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
              Welcome to Dream work shipping
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              Professional logistics solutions for businesses worldwide. Sign in to manage your shipments or create an account to get started.
            </p>
          </div>
        </div>

        {/* Login Form Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <LoginForm />
        </div>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}